import * as React from 'react';
import {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, DialogContent} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import {PubSub} from "./utility/PubSub";
import {StyledButton, StyledTypography} from "./providers/layout/LayoutProvider";

type DialogInfo = {
   title: string,
   subtitle: string,
   open: boolean,
   onConfirm: () => void,
   type: 'info' | 'confirm'
   yesText?: string
   noText?: string
   okayText?: string
}

type DialogProviderProps = {
   children: React.ReactNode | React.ReactNode[];
}

export type ConfirmOptions = {
   title: string,
   subtitle?: string
   yesText?: string
   noText?: string
   okayText?: string
}

const confirm = (options: ConfirmOptions, onConfirm: () => void) => {
   PubSub.emit('confirm', {
      title: options.title,
      subtitle: options.subtitle,
      yesText: options.yesText,
      noText: options.noText,
      onConfirm: onConfirm
   });
}
const info = (options: ConfirmOptions) => {
   PubSub.emit('info', {
      title: options.title,
      subtitle: options.subtitle,
      okayText: options.okayText
   });
}

export const Dialogs = {
   confirm,
   info
}

export const DialogProvider = (props: DialogProviderProps) => {
   const [info, setInfo] = useState<DialogInfo>({
      title: '',
      subtitle: '',
      open: false,
      type: 'confirm',
      onConfirm: () => {
      }
   });

   const onClose = () => {
      setInfo({
         ...info,
         open: false
      })
   }

   useEffect(() => {
      let confirmHandle = PubSub.on('confirm', (args: any) => {
         setInfo({
            title: args.title,
            subtitle: args.subtitle,
            onConfirm: args.onConfirm,
            yesText: args.yesText,
            noText: args.noText,
            open: true,
            type: 'confirm'
         })
      });

      let infoHandle = PubSub.on('info', (args: any) => {
         setInfo({
            title: args.title,
            subtitle: args.subtitle,
            okayText: args.okayText,
            open: true,
            type: 'info',
            onConfirm: () => {
            }
         })
      });

      return () => {
         confirmHandle();
         infoHandle();
      }
   }, [])

   return <>
      <MyDialog title={info.title}
                subtitle={info.subtitle}
                open={info.open}
                onConfirm={info.onConfirm}
                onClose={onClose}
                type={info.type}
                yesText={info.yesText}
                noText={info.noText}
                okayText={info.okayText}
      />
      {props.children}
   </>
}

type DialogProps = {
   title: string
   subtitle: string
   open: boolean;
   type: 'info' | 'confirm';
   onConfirm: () => void;
   onClose: () => void
   yesText?: string
   noText?: string
   okayText?: string
}

const MyDialog = (props: DialogProps) => {
   return (
      <Dialog
         open={props.open}
         onClose={props.onClose}
         aria-labelledby="confirm-dialog"
      >
         <DialogTitle id="confirm-dialog" sx={{textAlign: 'center'}}>
            <StyledTypography sx={{whiteSpace: "normal"}} type={"main"} variant={"h1"}>{props.title}</StyledTypography>
         </DialogTitle>
         <DialogContent>
            <DialogContentText color={"primary"} sx={{textAlign: 'center'}}>
               <StyledTypography sx={{whiteSpace: "normal"}} type={"main"} variant={"body1"}>{props.subtitle}</StyledTypography>
            </DialogContentText>
         </DialogContent>
         <DialogActions>
            <Box sx={{
               display: 'flex',
               flexDirection: 'column',
               width: '100%',
               gap: '10px',
               padding: '0px 20px 20px 20px'
            }}>
               <StyledButton
                  disableElevation={true}
                  styletype={"main"}
                  variant="contained"
                  onClick={() => {
                     props.onClose();
                     props.onConfirm && props.onConfirm();
                  }}
                  color="primary"
               >
                  {props.type === 'confirm' && <>{props.yesText || 'YES'}</>}
                  {props.type === 'info' && <>{props.okayText || 'Ok'}</>}
               </StyledButton>
               {props.type === 'confirm' && <StyledButton
                  disableElevation={true}
                  styletype={"main"}
                  variant="outlined"
                  onClick={props.onClose}
                  color="primary"
               >
                  {props.noText || 'NO'}
               </StyledButton>}
            </Box>
         </DialogActions>
      </Dialog>
   );
};

